"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCategory = exports.gaEvents = exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _link = require("@insided/deprecated-preact-components/menu/link");

var _list = _interopRequireDefault(require("@insided/deprecated-preact-components/menu/list"));

var _Types = require("./Types");

var _NestedCategoryList = _interopRequireDefault(require("./NestedCategoryList"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var gaEvents = function gaEvents(url) {
  return {
    eventCategory: 'Homepage',
    eventAction: 'Menu clicked',
    eventLabel: {
      Link: url
    }
  };
};

exports.gaEvents = gaEvents;

var trackCategory = function trackCategory(title, url, isParent) {
  return {
    type: "Mega Menu click on ".concat(isParent ? 'parent ' : '', "category"),
    category_title: title,
    category_url: url,
    click_source: 'menu',
    category_type: "".concat(isParent ? 'parent ' : '', "category"),
    event_source: 'control'
  };
};

exports.trackCategory = trackCategory;

var getTopicCount = function getTopicCount(category) {
  if ((0, _Types.hasTopicCount)(category)) {
    return category.topicCount;
  }

  if ((0, _Types.hasVisibleTopicsCount)(category) && !category.isContainer) {
    return category.visibleTopicsCount;
  }

  return undefined;
};

var CategoryList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryList, _Component);

  var _super = _createSuper(CategoryList);

  function CategoryList() {
    var _this;

    (0, _classCallCheck2.default)(this, CategoryList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "categoryLinksRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categoryDropdownOffsets: Array(_this.props.categoryList.length)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCategoryLinksRef", function (element, index) {
      if (!_this.categoryLinksRef.current) {
        return;
      }

      _this.categoryLinksRef.current[index] = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "alignNestedDropdown", function (categoryIndex) {
      var categoryMenuRef = _this.props.categoryMenuRef;

      if (!categoryMenuRef.current || !_this.categoryLinksRef.current) {
        return;
      }

      var categoryMenuScrollTop = categoryMenuRef.current.scrollTop;

      var categoryLinkHeight = _this.categoryLinksRef.current[categoryIndex].getBoundingClientRect().height;

      var newTopAlignment = -categoryMenuScrollTop - categoryLinkHeight - 8;

      _this.setState(function (_ref) {
        var categoryDropdownOffsets = _ref.categoryDropdownOffsets;
        categoryDropdownOffsets[categoryIndex] = newTopAlignment;
        return {
          categoryDropdownOffsets: categoryDropdownOffsets
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoryList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categoryList = this.props.categoryList;
      this.categoryLinksRef.current = Array(categoryList.length);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          categoryList = _this$props.categoryList,
          _getItemProps = _this$props.getItemProps,
          highlightedIndex = _this$props.highlightedIndex,
          onGlobalKey = _this$props.onGlobalKey,
          quickLinksClean = _this$props.quickLinksClean,
          popupName = _this$props.popupName,
          isHamburgerList = _this$props.isHamburgerList,
          isCustom = _this$props.isCustom;
      var categoryDropdownOffsets = this.state.categoryDropdownOffsets;
      return (0, _preact.h)(_list.default, {
        getItemProps: function getItemProps(idx) {
          return _getItemProps({
            item: categoryList[idx],
            className: (0, _classnames.default)('main-menu-list__item', 'main-menu-list__item--no-hover', {
              'main-menu-list__item--highlighted': quickLinksClean.length + idx === highlightedIndex
            })
          });
        }
      }, categoryList.map(function (category, index) {
        var id = category.id,
            title = category.title;
        var isTopLevel = category.parentId === null;
        var isContainer = category.isContainer;
        var isNestedContainer = !isTopLevel && isContainer && category.children.length > 0;
        var topicCount = getTopicCount(category);
        var hasUrl = ('url' in category);
        var categoryUrl = hasUrl ? category.url : (0, _urlGenerator.generateCategoryUrl)(title, id);
        var disableLink = isCustom && !hasUrl;
        var showCategoryAsLink = !disableLink && (!isNestedContainer || !isHamburgerList);
        var external = (0, _Types.hasExternalProperty)(category) ? category.external : undefined;
        var categoryLink = (0, _preact.h)("div", {
          ref: function ref(element) {
            return _this2.setCategoryLinksRef(element, index);
          }
        }, (0, _preact.h)(_link.CategoryLink, {
          key: id,
          id: "mega-menu-category-".concat(id),
          track: trackCategory(title, categoryUrl, isContainer),
          gaEvents: gaEvents(categoryUrl),
          tag: showCategoryAsLink ? 'a' : 'span',
          href: (0, _absoluteUrlRuntime.resolveUrl)(showCategoryAsLink ? categoryUrl : undefined),
          title: title,
          topicsCount: topicCount,
          isNested: isNestedContainer,
          isHamburger: isHamburgerList,
          external: external,
          onMouseEnter: isNestedContainer ? function () {
            return _this2.alignNestedDropdown(index);
          } : undefined
        }, isTopLevel ? (0, _preact.h)("strong", null, title) : title));

        if (isNestedContainer) {
          return (0, _preact.h)(_dropdown.default, {
            key: id,
            popupName: "".concat(popupName, "-").concat(id),
            className: isHamburgerList ? 'dropdown--forums-overview--nested-hamburger' : 'dropdown--forums-overview--nested',
            onGlobalKey: onGlobalKey,
            openOnHover: !isHamburgerList,
            trigger: categoryLink
          }, (0, _preact.h)(_NestedCategoryList.default, {
            category: category,
            getItemProps: _getItemProps,
            isHamburgerList: isHamburgerList,
            topOffset: categoryDropdownOffsets[index]
          }));
        }

        return categoryLink;
      }));
    }
  }]);
  return CategoryList;
}(_preact.Component);

var _default = CategoryList;
exports.default = _default;